interface IncludeFile {
  ok: boolean;
  status: number;
  html: string;
}

const includeFiles = new Map<string, Promise<IncludeFile>>();

function requestInclude(
  src: string,
  mode: 'cors' | 'no-cors' | 'same-origin' = 'cors'
): Promise<IncludeFile> {
  const existingFileDataPromise = includeFiles.get(src);
  if (existingFileDataPromise) {
    return existingFileDataPromise;
  }
  const fileDataPromise = fetch(src, { mode: mode }).then(async response => {
    return {
      ok: response.ok,
      status: response.status,
      html: await response.text(),
    };
  });
  includeFiles.set(src, fileDataPromise);
  return fileDataPromise;
}

type IconFile =
  | {
      ok: true;
      status: number;
      svg: string;
    }
  | {
      ok: false;
      status: number;
      svg: null;
    };

interface IconFileUnknown {
  ok: boolean;
  status: number;
  svg: string | null;
}

const iconFiles = new Map<string, IconFile>();

export async function requestIcon(url: string): Promise<IconFile> {
  const existingIconFile = iconFiles.get(url);
  if (existingIconFile) {
    return existingIconFile;
  }
  const fileData = await requestInclude(url);
  const iconFileData: IconFileUnknown = {
    ok: fileData.ok,
    status: fileData.status,
    svg: null,
  };
  if (fileData.ok) {
    const div = document.createElement('div');
    div.innerHTML = fileData.html;
    const svg = div.firstElementChild;
    iconFileData.svg =
      svg?.tagName.toLowerCase() === 'svg' ? svg.outerHTML : '';
  }
  iconFiles.set(url, iconFileData as IconFile);
  return iconFileData as IconFile;
}
